import axios from '../../axiosInstances/axiosInstance';

export const getRecentOrders = () => {
  return axios.get(`/users/recentOrders`);
};
